import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TColumn } from '../types/column.type';

export const UpdateColumnValidationSchema = z.object({
  spaceColumnId: z.string({ message: 'Space Column ID is required' }).min(1),
  name: z.string().optional(),
  columnIndex: z.string().optional(),
  color: z.string().optional(),
});

export type TUpdateColumnValidation = z.infer<typeof UpdateColumnValidationSchema>;
export type TUpdateColumnPayload = TUpdateColumnValidation;
export type TUpdateColumnResponse = ApiResponse<TColumn>;

export const updateColumn = async (payload: TUpdateColumnPayload): Promise<TUpdateColumnResponse> => {
  const url = `/space-column/${payload.spaceColumnId}`;

  return axiosInstance.patch(url, payload);
};

/**
 * Use Update Column React-Query Hook
 */
type UseUpdateColumnMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof updateColumn, AxiosErrorCustom>;
};

/**
 * Use Update Column React-Query Hook
 */
export const useUpdateColumnMutation = ({ mutationConfig }: UseUpdateColumnMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: updateColumn,
    ...restConfig,
  });
};
